import { useState } from 'react';
import { SxProps, Theme } from '@mui/material';
import useGetOnboarding from '../../../hooks/businesses/useGetOnboarding';
import usePersistedState from '../../../hooks/global/usePersistedState';
import FullOnboardingProgress from './FullOnboardingProgress';
import MinOnboardingProgress from './MinOnboardingProgress';
import OnboardingCategoryModal from '../OnboardingCategoryModal';
import { OnboardingModalCategory } from '../../../types/businesses';

interface Props {
  sx?: SxProps<Theme>;
}

function OnboardingProgress({ sx }: Props) {
  const { isEnabled, isOnboardingComplete, isLoading } = useGetOnboarding();
  const [canGoBack, setCanGoBack] = useState(false);
  const [modalCategory, setModalCategory] =
    useState<OnboardingModalCategory>(null);

  const [isMinimized, setIsMinimized] = usePersistedState(
    'onboardingMinimized',
    false,
    process.env.NODE_ENV === 'development' ? sessionStorage : localStorage,
  );

  const onMinimize = () => {
    setIsMinimized(true);
  };

  const onOpenModal = (category: OnboardingModalCategory) => {
    setModalCategory(prev => {
      setCanGoBack(prev === 'SETUP' && category !== 'SETUP');
      return category;
    });
  };

  if (!isEnabled || isLoading) return null;

  return (
    <>
      {!isOnboardingComplete &&
        (isMinimized ? (
          <MinOnboardingProgress sx={sx} onOpenModal={onOpenModal} />
        ) : (
          <FullOnboardingProgress
            sx={sx}
            onMinimize={onMinimize}
            onOpenModal={setModalCategory}
          />
        ))}
      <OnboardingCategoryModal
        category={modalCategory}
        setCategory={onOpenModal}
        canGoBack={canGoBack}
      />
    </>
  );
}

export default OnboardingProgress;
